<template>
    <div class="shadow">

        <!-- NEIN! -> das Feature ist dem Dashboard vorbehalten! -->
        <!--<ul class="list-reset flex">
            <li class="p-4 ml-2 rounded-t-lg" v-bind:class="{ 'bg-grey-light': isLine }"><a v-on:click="type='line'">Time
                Series</a></li>
            <li class="p-4 ml-2 rounded-t-lg" v-bind:class="{ 'bg-grey-light': isColumn }"><a
                    v-on:click="type='column'">Ranking</a></li>
        </ul>-->

        <div class="">
            <div class="panel-body">
                <div class="col-md-12">
                    <div v-bind:id="identifier"></div>
                </div>
            </div>
            <div class="bg-grey-lightest p-4 flex">
                <div class="">
                    <p>
                        <button class="btn btn-default" v-on:click="exportChart('image/svg+xml')">
                            <i class="fa fa-download"></i> SVG
                        </button>
                        <button class="btn btn-default" v-on:click="exportChart('image/png')">
                            <i class="fa fa-download"></i> PNG
                        </button>
                    </p>
                </div>
                <div>
                    <form action="/reports/create" method="get">
                        <input type="hidden" name="_token" :value="csrf">
                        <input type="hidden" name="series" :value="dashboard">
                        <input type="hidden" name="dashboard" value="true">
                        <input type="submit">
                    </form>
                </div>
            </div>
        </div>

    </div>


</template>

<script>

    export default {

        props: ['periodicity', 'headline', 'data', 'href', 'link', 'sources'],

        data: function () {
            return {
                chart: null,
                type: 'line',
                data: [],
            }
        },

        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            dashboard: function() {
                return this.data.map(function (item) {
                    return item.originalCode;
                }).join(',');
            },
            identifier: function () {
                return this.periodicity.en;
            },
            isLine: function () {
                return this.type === 'line';
            },
            isColumn: function () {
                return this.type === 'column';
            },
            yAxis: function () {
                const that = this;
                return this.data.map(function (data) {
                    return data.unit
                }).sort().filter(function (item, pos, ary) {
                    return !pos || item !== ary[pos - 1];
                }).map(function (axis) {
                    if (!that.isColumn) {
                        return axis;
                    }

                    return axis + ' (' + that.end + ')';
                });
            },
            excelLink: function () {
                return '/api/' + this.href;
            },
            editLink: function () {
                return '/sheets/create?link=' + this.link;
            },
            shareLink: function () {
                return '/sheets/share?link=' + this.link;
            },
            analyzeLink: function () {
                if (this.periodicity.en !== 'annual') {
                    return false;
                }
                if (this.data.length !== 1) {
                    return false;
                }

                return '/regression/' + this.data[0].originalCode;
            },
            series: function () {
                if (this.type === 'column') {
                    return this.latestSeries;
                }

                return this.timeSeries;
            },
            timeSeries: function () {
                var that = this;
                return this.data.map(function (field) {
                    var data = field.observations.filter(function (val) {
                        return val.value !== null && val.value !== '';
                    }).map(function (val) {
                        return [Date.parse(val.time), val.value];
                    });

                    var yIndex = that.yAxis.findIndex(function (axis) {
                        return axis === field.unit;
                    });

                    return {
                        name: field.description,
                        data: data,
                        yAxis: yIndex
                    };
                });
            },
            max: function () {
                let max = this.data[0].end;

                this.data.forEach(function (series) {
                    if (series.end > max) {
                        max = series.end;
                    }
                });

                return max
            },

            latestSeries: function () {
                // filter
                const that = this;
                let data = this.data.map(function (series) {
                    const filtered = series.observations.filter(function (val) {
                        return val.value !== null && val.value !== '';
                    });
                    series.latest = filtered[filtered.length - 1];

                    return series;
                }).map(function (series) {
                    let name = series.description;
                    if (series.latest.time !== that.max) {
                        name = name + ' (' + series.latest.time.substr(0, 4) + ')';
                    }
                    return [name, series.latest.value];
                });

                data = data.sort(function (a, b) {
                    if (a[1] < b[1]) {
                        return 1;
                    }
                    if (a[1] > b[1]) {
                        return -1;
                    }
                    return 0;
                });

                return [{
                    data: data,
                }];
            }
        },

        mounted: function () {
            this.newChart();
        },

        watch: {
            'type': function () {
                this.newChart();
            }
        },

        methods: {
            exportChart: function (type) {
                this.chart.exportChart({type: type});
            },

            newChart: function () {

                const text = this.headline.map(function (item) {
                    return item.dimension + ': ' + item.content;
                }).join('<br />');

                const id = this.identifier;

                const yAxis = this.yAxis.map(function (title) {
                    return {
                        title: {
                            text: title
                        }
                    };
                });

                let plotOptions = {};

                if (this.type === 'column') {
                    plotOptions = {
                        column: {
                            dataLabels: {
                                //allowOverlap: true,
                                /*enabled: true,
                                formatter: function() {
                                    console.log(this.point.name);
                                    return 'foo:' + this.point.name;
                                }*/
                            }
                        },
                    };
                }


                const json = {
                    chart: {
                        renderTo: id,
                        type: this.type,
                    },
                    plotOptions: plotOptions,
                    title: {
                        text: text,
                    },
                    series: this.series,
                    yAxis: yAxis,
                    legend: {
                        itemStyle: {
                            width: 550,
                        },
                        enabled: !this.isColumn,
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: {
                        enabled: false,
                        href: 'https://now.allthatstats.com/', // TODO link to one of the sources! ;-)
                        text: 'Source: ' + this.sources.join(" & "), // TODO broken!
                    },
                };

                if (this.isColumn) {

                    let categories = this.series[0].data.map(function (item) {
                        return item[0];
                    });

                    json.xAxis = {
                        categories: categories,
                        type: 'category',
                        title: {
                            text: null
                        },
                        labels: {
                            rotation: -45,
                        },
                        tickmarkPlacement: 'on',
                    };
                }

                this.chart = null;
                this.chart = new Highcharts.Chart(json);
            }
        }

    }

</script>